import { BRAND } from "../config/brand";
import BrandMark from "./BrandMark";
import "./topbar.css";

const TAB_TITLES = {
  summary: "Quote Summary",
  risk: "Risk & Classification",
  invoice: "Invoice Preview",
  clients: "Client Directory",
  admin: "Saved Jobs"
};

export default function Topbar({ toggleTheme, theme, activeTab = "summary" }) {
  const today = new Date().toLocaleDateString(undefined, {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric"
  });

  const pageTitle = TAB_TITLES[activeTab] || BRAND.productName;

  return (
    <header className="topbar">
      <div className="topbar__lead">
        <BrandMark variant="topbar" showTagline={false} />
        <div className="topbar__titles">
          <h1 className="topbar__page">{pageTitle}</h1>
          <p className="topbar__product">{BRAND.productName}</p>
        </div>
      </div>

      <div className="topbar__actions">
        <span className="topbar__date">{today}</span>

        <button
          type="button"
          className="btn btn-secondary topbar__theme"
          onClick={toggleTheme}
          aria-label="Toggle theme"
        >
          {theme === "dark" ? "☀ Light" : "☾ Dark"}
        </button>

        <div className="topbar__avatar" title={BRAND.name}>
          {BRAND.initials}
        </div>
      </div>
    </header>
  );
}
